import React from 'react';

export default function Sidebar({ prereqStatuses, integrations, onRefresh, refreshing, onViewChange, currentView }) {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <div className="compass-icon">N</div>
          <div>
            <h1>Compass</h1>
            <div className="sidebar-subtitle">VitalChain Business Advisor</div>
          </div>
        </div>
      </div>

      {/* Prerequisites */}
      <div className="sidebar-section">
        <h3>Prerequisites to Pilot</h3>
        {prereqStatuses.map(p => (
          <div key={p.id} className={`prereq-item ${p.status}`}>
            <div className={`prereq-dot ${p.status}`} />
            <div className="prereq-info">
              <h4>{p.name}</h4>
              <p>{p.detail}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Integrations */}
      <div className="sidebar-section">
        <h3>Integrations</h3>
        <div className="integration-list">
          <IntegrationRow name="Gmail" data={integrations.gmail} />
          <IntegrationRow name="Google Sheets" data={integrations.sheets} />
          <IntegrationRow name="n8n Workflows" data={integrations.n8n} />
          <IntegrationRow name="Google Calendar" data={integrations.calendar} />
          <IntegrationRow name="LinkedIn" data={{ status: 'email-fallback' }} />
        </div>
      </div>

      {/* Quick Actions */}
      <div className="sidebar-section">
        <h3>Quick Actions</h3>
        <div className="quick-actions">
          <button className="quick-action-btn" onClick={onRefresh} disabled={refreshing}>
            {refreshing ? 'Refreshing...' : 'Refresh All Data'}
          </button>
          <button className="quick-action-btn" onClick={() => onViewChange('briefing')}>
            View Daily Briefing
          </button>
          <button className="quick-action-btn" onClick={() => onViewChange('chat')}>
            Ask Compass a Question
          </button>
        </div>
      </div>

      {/* Pilot Targets */}
      <div className="sidebar-section">
        <h3>Pilot Targets</h3>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
          <div style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
            <strong style={{ color: 'var(--brand-teal)' }}>1. Vermont</strong> — Rural Health Transformation
          </div>
          <div style={{ padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
            <strong style={{ color: 'var(--brand-teal)' }}>2. Maine</strong> — MaineCare fraud history
          </div>
          <div style={{ padding: '6px 0' }}>
            <strong style={{ color: 'var(--brand-teal)' }}>3. New Hampshire</strong> — CMS program integrity
          </div>
        </div>
      </div>
    </div>
  );
}

function IntegrationRow({ name, data }) {
  if (!data) {
    return (
      <div className="integration-item">
        <span>{name}</span>
        <div className="integration-status">
          <div className="integration-dot checking" />
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Checking...</span>
        </div>
      </div>
    );
  }

  const isConnected = data.status === 'connected' || data.status === 'email-fallback';
  const isNotConfigured = data.status === 'not-configured';
  const label = data.status === 'email-fallback' ? 'Email fallback' :
    data.status === 'connected' ? 'Connected' :
    data.status === 'not-configured' ? 'Not configured' :
    data.status === 'no-data' ? 'No data' :
    data.status === 'error' ? 'Error' : 'Disconnected';

  const dotClass = isConnected ? 'connected' : isNotConfigured ? 'checking' : 'disconnected';

  return (
    <div className="integration-item">
      <span>{name}</span>
      <div className="integration-status">
        <div className={`integration-dot ${dotClass}`} />
        <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{label}</span>
      </div>
    </div>
  );
}
